import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import './LeadingEmployers.css';

const LeadingEmployersComponent = ({ employers }) => {
  const sortedEmployers = [...employers].sort((a, b) => {
    if (a.employees && b.employees) {
      let aEmployees = parseInt(a.employees.replace(/,/g, ''), 10);
      let bEmployees = parseInt(b.employees.replace(/,/g, ''), 10);
      if (isNaN(aEmployees)) aEmployees = 0;
      if (isNaN(bEmployees)) bEmployees = 0;
      return bEmployees - aEmployees;
    }
    return 0;
  });

  return (
    <div>
      {sortedEmployers.map((employer, index) => (
        <div className="leading-employers" key={index}>
          <p>
            <ViewerPrimaryColorUserStyle domStyle="color">
              <b>{index + 1}&nbsp;</b>
            </ViewerPrimaryColorUserStyle>
            <b>{employer.name}</b>
          </p>
          {(employer.city || employer.state) &&
            <p>
              Location: {employer.city}
              {employer.city && employer.state && <span>, </span>}
              {employer.state}
            </p>
          }
          {employer.employees && <p>Employees: {employer.employees}</p>}
          {employer.productOrService && <p>Product or Service: {employer.productOrService}</p>}
        </div>
      ))}
    </div>
  );
};

LeadingEmployersComponent.propTypes = {
  employers: PropTypes.arrayOf(PropTypes.shape({
    employees: PropTypes.string,
    name: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    productOrService: PropTypes.string,
  })),
};

export default LeadingEmployersComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaDetails/LeadingEmployers.js